import { withDefault, StringParam } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
  AccountingJobTypeEnum,
  AccountingJobStateEnum,
} from '@ui/src';

export const columns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'type',
    label: 'Type',
    sortable: true,
  },
  {
    name: 'state',
    label: 'Status',
    sortable: true,
  },
  {
    name: 'createdAt',
    label: 'Created',
    sortable: true,
  },
  {
    name: 'periodFrom',
    label: 'Date From',
    sortable: true,
  },
  {
    name: 'periodTo',
    label: 'Date To',
    sortable: true,
  },
  {
    name: 'accountsIds',
    label: 'Accounts',
    sortable: false,
  },
  {
    name: 'fullCurrentDate',
    label: 'Processing Date',
    sortable: false,
  },
  {
    name: 'progress',
    label: 'Progress',
    sortable: false,
  },
  {
    name: 'startedAt',
    label: 'Started',
    sortable: false,
  },
  {
    name: 'finishedAt',
    label: 'Finished',
    sortable: false,
  },
  {
    name: 'duration',
    label: 'Duration (hh:mm)',
    sortable: false,
  },
];

export const columnsLabels = {
  type: 'Type',
  state: 'Status',
};

export const defaultSorter = {
  sortProp: columns[3].name,
  sortDir: SortDir.DESC,
};

export const schema = {
  type: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  state: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  sortProp: {
    value: withDefault(StringParam, defaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, defaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const filtersSchema = [
  {
    name: 'type',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'type',
        title: 'Closing balances + Reports + Revaluations',
        value: AccountingJobTypeEnum.BALANCES_LOGS,
      },
      {
        name: 'type',
        title: 'Reports',
        value: AccountingJobTypeEnum.BALANCE_SHEET,
      },
      {
        name: 'type',
        title: 'Revaluations',
        value: AccountingJobTypeEnum.REVALUATION,
      },
      {
        name: 'type',
        title:
          'Recalculation of transaction amounts in the base currency + Creation of missing statement items',
        value: AccountingJobTypeEnum.POST_PROCESSING,
      },
    ],
  },
  {
    name: 'state',
    type: FilterType.CHECKBOX,
    withClearButton: true,
    fields: [
      {
        name: 'state',
        title: 'New',
        value: AccountingJobStateEnum.NEW,
      },
      {
        name: 'state',
        title: 'Queued',
        value: AccountingJobStateEnum.QUEUED,
      },
      {
        name: 'state',
        title: 'In Progress',
        value: AccountingJobStateEnum.IN_PROGRESS,
      },
      {
        name: 'state',
        title: 'Failed',
        value: AccountingJobStateEnum.FAILED,
      },
      {
        name: 'state',
        title: 'Cancelled',
        value: AccountingJobStateEnum.CANCELLED,
      },
      {
        name: 'state',
        title: 'Done',
        value: AccountingJobStateEnum.DONE,
      },
    ],
  },
];
